import React from 'react'

interface IAttributeOption {
  name: string
  unit: string | undefined
}

interface IAttributeSelectorProps {
  attributeList: IAttributeOption[]
  selectedAttribute: string | undefined
  setSelectedAttribute: (attribute: string) => void
  children: React.ReactNode
}

interface IAttributeButtonProps {
  isSelected: boolean
  onClick: () => void
  children: React.ReactNode
}

const AttributeButton = ({
  isSelected,
  onClick,
  children
}: IAttributeButtonProps) => {
  return (
    <button
      type='button'
      className={[
        'block px-4 py-2 w-full',
        'text-left font-semibold',
        'bg-lighthouseBlue bg-opacity-30',
        isSelected ? '' : 'opacity-50 !bg-opacity-20',
        'cursor-pointer'
      ].join(' ')}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

/**
 * Edit Threshold modal sidebar component
 */
export const AttributeSelector = ({
  attributeList,
  selectedAttribute,
  setSelectedAttribute,
  children
}: IAttributeSelectorProps) => {
  return (
    <div className='tracking-tight'>
      <div className='mb-8 font-bold text-blue-navy uppercase'>{children}</div>
      <div>
        <div className='my-2 font-semibold'>Attributes:</div>
        <div className='rounded overflow-hidden'>
          {attributeList.map((attribute) => (
            <AttributeButton
              key={attribute.name}
              isSelected={selectedAttribute === attribute.name}
              onClick={() => setSelectedAttribute(attribute.name)}
            >
              <>
                {attribute.name}
                {attribute.unit && (
                  <span className='ml-1'>
                    (<span className='italic'>{attribute.unit}</span>
                    <span className='ml-0.5'>)</span>
                  </span>
                )}
              </>
            </AttributeButton>
          ))}
        </div>
      </div>
    </div>
  )
}
